export function isTemporaryProjectId(id?: string) {
  return id?.slice?.(0, 4) === "tmp_";
}
